module.exports = {
  "notification": {
    notification: "消息",
    notificationType2: "系统消息",
    notificationType1: "通知公告",
    viewDetails: "查看详情",
    notificationDetails: "通知详情"
  },
}


// WEBPACK FOOTER //
// ./src/i18n/notification/zh-CN.js